import { Link } from "react-router-dom";

import { Text } from "$components";
import { useStyles } from "../styles/ProfileEDB.styles";

type ReferenceLinkProps = {
  to: string;
  label: string;
};

export default function ReferenceLink({ to, label }: ReferenceLinkProps) {
  const classes = useStyles();
  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <Text className={classes.headTextRefs}>{label}</Text>
    </Link>
  );
}
